import React, { useEffect } from 'react';
import { LAYER_CATEGORY_CAPABILITY } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useFetchSpatialLayers from '../../hooks/useFetchSpatialLayers';
import { MapLayersControl } from './MapLayersControl';
import { MapLayersControlWithTabs } from './MapLayersControlWithTabs';
import { trackMapLayersControlView } from './mapLayersControlTrackings';
import { useForceOffOldCRGWhenWFSPresent } from './useForceOffOldCRGWhenWFSPresent';

/**
 * Container for Map Layers UI.
 * Fetches spatial layers, then gates on the layer_category capability
 * to render either the tabbed or flat-list version.
 *
 * Once layer_category is enabled for all PSAPs, delete
 * MapLayersControl.js and render MapLayersControlWithTabs directly.
 */
const MapLayersControlContainer = () => {
  const isFetched = useFetchSpatialLayers();
  const { hasCapability } = useHasCapability(LAYER_CATEGORY_CAPABILITY);

  useForceOffOldCRGWhenWFSPresent();

  useEffect(() => {
    if (!isFetched) {
      return;
    }
    trackMapLayersControlView({
      layout: hasCapability ? 'tabs' : 'flat',
    });
  }, [isFetched, hasCapability]);

  if (!isFetched) {
    return null;
  }

  return hasCapability ? <MapLayersControlWithTabs /> : <MapLayersControl />;
};

export default MapLayersControlContainer;
